import React from 'react';
import ReactDOM from 'react-dom';
import App from './jsx/App';
import 'typeface-open-sans';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
